import { render } from "./ModalPhotoAdvice.vue?vue&type=template&id=c06fc4aa&scoped=true"
import script from "./ModalPhotoAdvice.vue?vue&type=script&lang=js"
export * from "./ModalPhotoAdvice.vue?vue&type=script&lang=js"

import "./ModalPhotoAdvice.vue?vue&type=style&index=0&id=c06fc4aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06fc4aa"]])

export default __exports__